import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ArrowRight, CheckCircle2 } from 'lucide-react';
import { WA_LINK } from '../lib/constants';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-light pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-63">
      <div className="container mx-auto px-4 md:px-6" data-id="element-64">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center" data-id="element-65">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-66">
            <div className="mb-6 inline-flex items-center rounded-full bg-white px-3 py-1 text-sm font-medium text-brand-dark shadow-sm" data-id="element-67">
              <span className="flex h-2 w-2 rounded-full bg-brand-accent mr-2" data-id="element-68"></span>
              Atención directa y profesional
            </div>

            <h1 className="mb-6 text-4xl font-bold tracking-tight text-brand-dark sm:text-5xl lg:text-6xl" data-id="element-69">
              Atención dental clara, rápida y enfocada en solucionar
            </h1>

            <p className="mb-8 text-lg leading-relaxed text-slate-600 sm:text-xl" data-id="element-70">
              Consulta dental para pacientes que buscan orientación directa,
              tratamientos bien explicados y una atención sin vueltas
              innecesarias.
            </p>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-71">
              <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-accent px-8 py-4 text-base font-semibold text-white shadow-lg transition-all hover:bg-brand-accentHover hover:shadow-xl hover:-translate-y-0.5" data-id="element-72">
                <MessageCircle size={20} data-id="element-73" />
                Consultar por WhatsApp
              </a>
              <a href="#servicios" className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand-dark shadow-sm transition-all hover:bg-slate-50" data-id="element-74">
                Ver servicios dentales
                <ArrowRight size={20} data-id="element-75" />
              </a>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4 text-sm font-medium text-slate-600 sm:gap-6" data-id="element-76">
              <div className="flex items-center gap-1.5" data-id="element-77">
                <CheckCircle2 size={18} className="text-brand-accent" data-id="element-78" />
                <span data-id="element-79">Atención directa</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-80">
                <CheckCircle2 size={18} className="text-brand-accent" data-id="element-81" />
                <span data-id="element-82">Orientación clara</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-83">
                <CheckCircle2 size={18} className="text-brand-accent" data-id="element-84" />
                <span data-id="element-85">Tratamientos enfocados en solución</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-86">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl" data-id="element-87">
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?q=80&w=2070&auto=format&fit=crop" alt="Consulta dental moderna y profesional" className="h-[500px] w-full object-cover lg:h-[600px]" data-id="element-88" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/40 to-transparent" data-id="element-89"></div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -left-6 rounded-xl bg-white p-4 shadow-xl sm:p-6" data-id="element-90">
              <div className="flex items-center gap-4" data-id="element-91">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-light text-brand-dark" data-id="element-92">
                  <MessageCircle size={24} data-id="element-93" />
                </div>
                <div data-id="element-94">
                  <p className="text-sm font-medium text-slate-500" data-id="element-95">
                    Respuesta rápida
                  </p>
                  <p className="font-bold text-brand-dark" data-id="element-96">Vía WhatsApp</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}